import React from "react";
import FAIcon from "../../Icons/FAIcon";
import { CopyToClipboard } from "react-copy-to-clipboard";
import HostPortalActions from "./HostPortalActions";

export default function OrdersGridItem({ key, order }) {
    const enablePaymentLink = order.balance.amount != 0;
    const linkColor = enablePaymentLink ? "#2da399" : "#999";
    const showPaymentLinkActions = !!order.paymentLink;

    const emailPaymentLinkClick = (order) => {
        if (!enablePaymentLink) return;
        HostPortalActions.sendCartPaymentLink(order.event, order.code);
    };

    const faIcon = (cardType) => {
        let iconName = "";
        if (cardType === "cart") iconName = "";
        else if (cardType === "weborder") iconName = "globe";
        else if (cardType === "host") iconName = "home";
        else if (cardType === "consultant") iconName = "user";

        return (
            <span style={{ marginRight: "5px" }}>
                <FAIcon name={iconName} size={24} fill="#2da399" inline={true} />
            </span>
        );
    };

    return (
        <tr key={key}>
            <td>
                {faIcon(order.cardType.toLowerCase())}
                {order.accountName}
            </td>
            <td className="text-right">{order.orderTotal.displayValue}</td>
            <td className="text-center">{order.bookings}</td>
            <td className="text-right">{order.balance.displayValue}</td>
            <td>
                {showPaymentLinkActions && (
                    <div>
                        <span style={{ margin: "auto 5px" }}>
                            <CopyToClipboard text={enablePaymentLink ? order.paymentLink : ""}>
                                <FAIcon name="copy_link" size={24} fill={linkColor} inline={true} tooltip="Copy Payment Link" />
                            </CopyToClipboard>
                        </span>
                        <span>
                            <FAIcon name="envelope_o" size={24} fill={linkColor} inline={true} tooltip="Email Payment Link" nada={order.accountEmailAddress} onClick={() => emailPaymentLinkClick(order)} />
                        </span>
                    </div>
                )}
            </td>
        </tr>
    );
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_Orders_Grid_Item.js